import { useState } from "react";
import apiCoreAdapter from "../../../../hooks/apiCoreAdapter";
import { useToast } from "../../../../hooks/useToast";
import {
  invalidateSessionsCache,
  invalidatePatientsCache,
} from "../data";
import type { SessionWithPsychologist } from "../data";
import { getRealSessionId } from "../../../../pages/psychologist/tabs/calendar/utils/getRealSessionId";

import { activityTracker } from "../../../../utils/activityTracker";
export function useCalendarSession() {
  const { showSuccess, showError } = useToast();
  const [isCancelling, setIsCancelling] = useState(false);
  const [selectedSession, setSelectedSession] = useState<SessionWithPsychologist | null>(null);
  const [isSessionModalOpen, setIsSessionModalOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleCancelSession = async (sessionId: string, motiveId?: string, note?: string, initiatedBy?: string) => {
    setIsCancelling(true);
    setIsSessionModalOpen(false);

    try {
      let realSessionId = sessionId;
      try {
        realSessionId = await getRealSessionId(
          sessionId,
          selectedSession?.date,
          selectedSession?.time,
          selectedSession?.patient?.email,
        );
      } catch {
        showError(
          "No se pudo encontrar la sesión. Por favor, recargá la página e intentá nuevamente.",
        );
        return;
      }

      await apiCoreAdapter.cancelSession(realSessionId, { motive_id: motiveId, note, initiated_by: initiatedBy });
      activityTracker.trackAction("session_cancelled"); // Métricas de Actividad: solo el hecho, nunca el motivo ni la nota
      showSuccess("Sesión cancelada exitosamente");
      setSelectedSession(null);
      invalidateSessionsCache();
      invalidatePatientsCache();
      setRefreshKey((prev) => prev + 1);
    } catch (error) {
      console.error("Error al cancelar sesión:", error);
      showError("Error al cancelar la sesión. Por favor, intentá nuevamente.");
    } finally {
      setIsCancelling(false);
    }
  };

  const handleCloseSessionModal = () => {
    setIsSessionModalOpen(false);
    setSelectedSession(null);
  };

  return {
    isCancelling,
    selectedSession,
    setSelectedSession,
    isSessionModalOpen,
    setIsSessionModalOpen,
    refreshKey,
    handleCancelSession,
    handleCloseSessionModal,
  };
}
